import { paperClasses, type Components } from '@mui/material';
import { themeVars } from '../themeVars';
import type { Theme } from './utils';

export const MuiCard: Components<Theme>['MuiCard'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&:not(.${paperClasses.outlined})`]: {
        '--background': themeVars(theme).palette.background.level1,
      },
      // Using :where to reduce specificity to 0
      [`&.${paperClasses.outlined}`]: {
        '--border': `1px solid ${themeVars(theme).palette.border.subtle}`,
      },
      borderRadius: theme.shape.borderRadius,
      background: 'var(--background)',
      border: 'var(--border)',
    }),
  },
};

export const MuiCardHeader: Components<Theme>['MuiCardHeader'] = {
  styleOverrides: {
    action: {
      marginRight: 0,
      marginTop: -2,
    },
  },
};

export const MuiCardActions: Components<Theme>['MuiCardActions'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2),
      display: 'flex',
      justifyContent: 'stretch',
    }),
  },
};
